import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { getAuth, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';

/** Firebase web config is public by design; restrict the API key to our domains in the Firebase console. */
const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
};

export const firebaseConfigured = Boolean(config.apiKey && config.projectId);

const app = initializeApp(
  firebaseConfigured ? config : { apiKey: 'unconfigured', projectId: 'unconfigured', authDomain: 'localhost' },
);

// In the native apps getAuth() never settles: its popup/redirect resolver needs an iframe the WebView can't load,
// so onAuthStateChanged never fires. Sign-in there goes through the native plugin, so no resolver is needed.
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);

/** Firebase sends verification and reset emails, and shows Google's screens, in this language. */
export function setAuthLanguage(locale: string) {
  try {
    auth.languageCode = locale;
  } catch {
    /* not configured (local development) */
  }
}
